import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { RiLayoutGridLine, RiTableLine } from 'react-icons/ri';

interface Props {
  tableLayout: boolean;
  onChange: (tableLayout: boolean) => void;
}

export const CardTableViewToggle = ({ tableLayout, onChange }: Props) => (
  <Button
    variant="filter"
    startIcon={tableLayout ? <RiLayoutGridLine /> : <RiTableLine />}
    onClick={() => onChange(!tableLayout)}
    sx={{ flexShrink: 0 }}
  >
    <FormattedMessage id={tableLayout ? 'portfolio.card_view' : 'portfolio.table_view'} />
  </Button>
);
